import { render } from "./RecipePage.vue?vue&type=template&id=a79c94f4&scoped=true"
import script from "./RecipePage.vue?vue&type=script&lang=js"
export * from "./RecipePage.vue?vue&type=script&lang=js"

import "./RecipePage.vue?vue&type=style&index=0&id=a79c94f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79c94f4"]])

export default __exports__